import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'defaultValue' })
export class DefaultValuePipe implements PipeTransform {
	public transform(value: string | null | undefined): string {
		return value ? value : '---';
	}
}
